// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__zWRU2","rotatingCoin":"LoadingSpinner_rotatingCoin__LpsOJ","flip":"LoadingSpinner_flip__HQ4U4"};